require('../modules/web.url');
require('../modules/web.url.to-json');
require('../modules/web.url-search-params');



// WEBPACK FOOTER //
// /Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/core-js/proposals/url.js